
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pizza",
      function () {
        return require("private-next-pages/pizza/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pizza"])
      });
    }
  